"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sizesMap = exports.textContrastColorMap = exports.colorsMap = exports.typesMap = void 0;
var ButtonProps_1 = require("./ButtonProps");
var styles = require("./Button.css");
exports.typesMap = new Map([
    [ButtonProps_1.ButtonType.PRIMARY, styles.primary],
    [ButtonProps_1.ButtonType.TEXT, styles.text],
    [ButtonProps_1.ButtonType.SIMPLE_TEXT, styles.simpletext],
    [ButtonProps_1.ButtonType.SQUARE, styles.square],
    [ButtonProps_1.ButtonType.GHOST, styles.ghost],
    [ButtonProps_1.ButtonType.GHOST_SQUARE, styles.ghostSquare],
    [ButtonProps_1.ButtonType.BLACK, styles.black],
]);
exports.colorsMap = new Map([
    [ButtonProps_1.ButtonColor.ORANGE, styles.orange],
    [ButtonProps_1.ButtonColor.BLUE, styles.blue],
    [ButtonProps_1.ButtonColor.PRIMEGREEN, styles.primegreen],
    [ButtonProps_1.ButtonColor.EMERALDGREEN, styles.emeraldgreen],
    [ButtonProps_1.ButtonColor.GREEN, styles.green],
    [ButtonProps_1.ButtonColor.WHITE, styles.white],
    [ButtonProps_1.ButtonColor.TRANSPARENT, styles.transparent],
    [ButtonProps_1.ButtonColor.COBALT, styles.cobalt],
]);
exports.textContrastColorMap = new Map([
    [ButtonProps_1.TextColor.CONTRASTBLUE, styles.contrastBlue],
]);
exports.sizesMap = new Map([
    [ButtonProps_1.ButtonSize.LARGE, styles.large],
]);
//# sourceMappingURL=ButtonStylesMaps.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Button/ButtonStylesMaps.js
// module id = 1104
// module chunks = 8